/* RESPONSIBLE TEAM: team-standalone */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAIAgentA2aAgentsRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAIAgentA2aAgentsRoute, {
  overrideRenderTemplate: false,
});
